// Libraries.
import { scarpaGray500, turquoise800 } from '@habitech/shared';
import styled from 'styled-components';

export const Contenedor = styled.div`
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    height: ${(props) => (props.height ? props.height : '100vh')};
    width: ${(props) => (props.widthPrincipal ? props.widthPrincipal : 'auto')};
    &.loader-button {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        margin: auto;
        .pcom-loading {
            height: 56px;
            svg:nth-child(1) {
                height: 24px;
            }
        }
    }
    .loadingTittle {
        color: ${scarpaGray500};
        margin-top: 20px;
        text-align: center;
    }
    .pcom-loading {
        display: grid;
        align-items: center;
        grid-template-rows: 60px 25px;
        .pcom-spinner {
            -webkit-animation: rotation 1.4s linear infinite;
            animation: rotation 1.4s linear infinite;
        }
        svg:nth-child(1) {
            stroke: gray;
            width: 100%;
            height: ${(props) => (props.heightSvg ? props.heightSvg : '60px')};
            stroke-width: 6px;
        }
        .pcom-circle {
            stroke: ${turquoise800};
            stroke-dasharray: 187;
            stroke-dashoffset: 0;
            -webkit-transform-origin: center;
            -ms-transform-origin: center;
            transform-origin: center;
            -webkit-animation: turn 1.4s ease-in-out infinite;
            animation: turn 1.4s ease-in-out infinite;
        }

        @-webkit-keyframes rotation {
            0% {
                -webkit-transform: rotate(0deg);
                transform: rotate(0deg);
            }
            100% {
                -webkit-transform: rotate(270deg);
                transform: rotate(270deg);
            }
        }

        @keyframes rotation {
            0% {
                -webkit-transform: rotate(0deg);
                transform: rotate(0deg);
            }
            100% {
                -webkit-transform: rotate(270deg);
                transform: rotate(270deg);
            }
        }

        @-webkit-keyframes turn {
            0% {
                stroke-dashoffset: 187;
            }
            50% {
                stroke-dashoffset: 46.75;
                -webkit-transform: rotate(135deg);
                transform: rotate(135deg);
            }
            100% {
                stroke-dashoffset: 187;
                -webkit-transform: rotate(450deg);
                transform: rotate(450deg);
            }
        }

        @keyframes turn {
            0% {
                stroke-dashoffset: 187;
            }
            50% {
                stroke-dashoffset: 46.75;
                -webkit-transform: rotate(135deg);
                transform: rotate(135deg);
            }
            100% {
                stroke-dashoffset: 187;
                -webkit-transform: rotate(450deg);
                transform: rotate(450deg);
            }
        }
    }
`;
